if (!customElements.get('sticky-shop-cta')) {
  customElements.define(
    'sticky-shop-cta',
    class StickyShopCta extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.trigger = document.querySelector(this.dataset.trigger);

        if (!this.link || !this.trigger) return;

        this.setVisible(false);
        this.observer = new IntersectionObserver(([entry]) => {
          const triggerHasPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.setVisible(triggerHasPassed);
        });
        this.observer.observe(this.trigger);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        this.link?.setAttribute('tabindex', visible ? '0' : '-1');
      }
    }
  );
}
